module.exports = __webpack_public_path__ + "static/media/ic_clip.3da4c508.svg";